
export enum TenantSettingGroup {
  GeneralSettings = 'general.setting',
  Operations = 'operations',
  Recommendations = 'recommendations',
}

export enum TenantSettingKey {
  GeneralSetting = 'general.setting',
  OperationsMaximumRecords = 'operations.max.records',
  XeroConsumerKey = 'accounting.xero.consumer.key',
  XeroConsumerSecret = 'accounting.xero.consumer.secret',
  ExcludeFromRecommendations = 'recommendations.exclude',
  RecommendationLimit = 'recommendations.limit',
  Search = 'search',
  SchedulerEnableSubContractors = 'scheduler_enable_subcontractors',
  TenantPlan = 'tenant.plan',
  SaleQuoteSetting = 'sales.quoteSetting',
  EmbedEmailAttachments = 'embed.email.attachments',
  UniversalChangeStreamResumeToken = 'universal.change.stream.resume.token',
  OutlookActivityKind = 'outlook.activity.kind',
  RecurringJobSchedulerBatchSize = 'recurring.job.scheduler.batch.size',
  JobAttributeFilterLastRunDate = 'job.attribute.filter.last.run.date',
  SiteAttributeFilterLastRunDate = 'site.attribute.filter.last.run.date',
  ContactAttributeFilterLastRunDate = 'contact.attribute.filter.last.run.date',
  PersistHomesNSWWebhookSettings = 'persist.homesnsw.webhook.settings',
  TenantSecuritySettings = 'tenant.security.settings',
  TenantSecurityPreventLogin = 'tenant.security.prevent.login',
}

export interface TenantSetting {
  _id: TenantSettingKey;
  value: any;
}
